import { useState } from "react";

function LearnMoreSection() {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
    <div className="p-2 text-center">

        {/* Text shows up when section is Expanded */}
         {isExpanded && (
        <p className="text-center mx-10 mb-2">
            <p>
            The IISS provides a quick way to understand the severity of a head
            injury. A score above 30% threshold indicates that the person
            <span className="font-bold italic"> should </span>
            have experienced a Loss of Consciousness (LOC). The IISS is a{" "}
            <a
              href="https://nsuworks.nova.edu/neurosports/vol1/iss2/19/"
              className="text-teal-600"
            >
              peer-reviewed
            </a>{" "}
            Class 2, FDA Clinical Decision Support tool, designed to help
            practitioners reduce life-changing concussions or TBIs.
          </p> 
        </p>
      )}

      {/* toggle button */}
      <button onClick={() => setIsExpanded(!isExpanded)} className="text-teal-600 text-sm font-semibold cursor-pointer">
        {isExpanded ? 'Show Less' : 'Learn More'}
      </button>
    </div>
  );
}

export default LearnMoreSection;

        
    
